import { Button, Flex } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface FecImportMappingActionsProps {
  isNextDisabled?: boolean
  onBack: () => void
  onNext: () => void
}

export const FecImportMappingActions = ({
  isNextDisabled = false,
  onBack,
  onNext,
}: FecImportMappingActionsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex justifyContent="space-between" width="100%">
      <Button icon="arrowLeft" onClick={onBack} variant="outlined">
        {t('settings.organization.accounting.fec_file_import.modal.mapping_step.back_button')}
      </Button>
      <Button disabled={isNextDisabled} iconRight="arrowRight" onClick={onNext} variant="tonal">
        {t('settings.organization.accounting.fec_file_import.modal.mapping_step.next_button')}
      </Button>
    </Flex>
  )
}
